import { useEffect, useState } from 'react';
import { Container, Col, Card, CardBody, Table, Button } from "reactstrap";
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";
import { API_BASE_URL, API_KEY, getCookie, sessionExpired } from "../Helper/utils";
import axios from 'axios';

const DeleteCase = () => {
    const [apiData, setApiData] = useState([]);

    useEffect(() => {
        fetchCases();
    }, []);

    const fetchCases = () => {
        const config = {
            method: 'post',
            url: `${API_BASE_URL}/api/verificationList`,
            headers: {
                apikey: API_KEY,
                Authorization: `Bearer ${getCookie("at")}`,
                'Content-Type': 'application/json'
            },
            data: JSON.stringify({})
        };

        axios(config)
            .then((response) => {
                // Sort by createdOn descending (most recent first)
                const sortedData = response.data.sort((a, b) => {
                    return new Date(b.createdOn) - new Date(a.createdOn);
                });

                setApiData(sortedData);
            })
            .catch((error) => {
                console.log(error);
                handleNon200Response(error);
            });
    };



    const handleNon200Response = (error) => {
        if (
            error.response &&
            error.response.status === 401 &&
            error.response.data.message === "User Not authenticated"
        ) {
            sessionExpired();
        }
    };

    const deleteCase = (agent) => {
        if (window.confirm(`Are you sure you want to delete agent "${agent.name}"?`)) {
            const config = {
                method: 'delete',
                url: `${API_BASE_URL}/api/verification/${agent._id}`,
                headers: {
                    apikey: API_KEY,
                    Authorization: `Bearer ${getCookie("at")}`,
                    'Content-Type': 'application/json'
                }
            };

            axios(config)
                .then((response) => {
                    if (response.status === 200) {
                        alert("Deleted Successfully!");
                        fetchCases(); // Refresh list
                    }
                })
                .catch((error) => {
                    console.log(error);
                    handleNon200Response(error);
                });
        }
    };

    return (
        <Container className="basic_table" fluid>
            <Breadcrumbs
                mainTitle={"Delete Cases"}
                parent={"Masters"}
                title={"Agent"}
            />
            <Col xl={12}>
                <Card className="height-equal">
                    <CardBody className="custom-input">
                        <div style={{ overflowY: 'auto' }}>
                            <Table className="display order-wrapper" id="delete-agent-table">
                                <thead>
                                    <tr>
                                        <th>Sl.No</th>
                                        <th>Name</th>
                                        <th>email</th>
                                        <th>Address</th>
                                        <th>Status</th>
                                        <th>Delete</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {apiData.map((agent, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{agent.name}</td>
                                            <td>{agent.email}</td>
                                            <td>{agent.address}</td>
                                            <td>{agent.status}</td>
                                            <td>
                                                <Button color="danger" onClick={() => deleteCase(agent)}>
                                                    Delete
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </Container>
    );
};

export default DeleteCase;
